import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Team } from '../models';

@Injectable()
export abstract class TeamsService {
    abstract createTeam(name: string, tagsIds: string[]): Promise<string>;

    abstract deleteTeam(teamId: string): Promise<void>;

    abstract team(teamId: string): Promise<Team | undefined>;

    abstract teams(): Observable<Team[]>;

    abstract updateTeam(teamId: string, data: { name?: string; tagsIds?: string[]; usersIds?: string[] }): Promise<void>;
}
